export const initialState = (inputResponse: any, isEdit = false) => {
  // if (isEdit) {
  //   let outputObject = {};
  //   for (const key in inputResponse) {
  //     outputObject = {
  //       ...outputObject,
  //       [key]: { value: inputResponse[key], error: "" },
  //     };
  //   }
  //   return outputObject;
  // } else
  return {
    // formName: { value: inputResponse.name ?? '', error: '' },
    // phone: { value: inputResponse.phone ?? '', error: '' },
    // dob: { value: inputResponse.dob ?? '', error: '' },
    // whatsapp: { value: inputResponse.whatsapp ?? '', error: '' },
    // martial_status: { value: inputResponse.martial_status ?? '', error: '' },
    // gender: { value: inputResponse.gender ?? '', error: '' },
    // address1: { value: inputResponse.address1 ?? '', error: '' },
    // address2: { value: inputResponse.address2 ?? '', error: '' },
    // email: { value: inputResponse.email ?? '', error: '' },
    // country_id: { value: inputResponse.country_name ?? '', id: inputResponse.country_id ?? '', error: '' },
    // state_id: { value: inputResponse.state_name ?? '', id: inputResponse.state_id ?? '', error: '' },
    // city: { value: inputResponse.city ?? '', error: '' },
    // zipcode: { value: inputResponse.zipcode ?? '', error: '' },
    // doj: { value: inputResponse.doj ?? '', error: '' },
    // password: { value: inputResponse.password ?? 'Admin@1234', error: '' },
    // employee_id: { value: inputResponse.employee_id ?? '', error: '' },
    // id: { value: inputResponse._id ?? '', error: '' },
    // profile_image: { value: inputResponse.profile_image, error: '' },
    leadName: { value: inputResponse.leadName ?? "", error: "" },
    leadEmail: { value: inputResponse.leadEmail ?? "", error: "" },
    leadPhone: { value: inputResponse.leadPhone ?? "", error: "" },
  };
};

export const handleValidation = (rawInput: any) => {
  if (
    rawInput.leadName?.value === "" &&
    rawInput.leadName?.value?.length === 0
  ) {
    rawInput.leadName.error = "Please enter valid name";
  }
  if (rawInput.leadPhone?.value.length !== 10) {
    rawInput.leadPhone.error = "Please enter valid phone number";
  }

  if (rawInput.leadEmail?.value.length === "") {
    rawInput.leadEmail.error = "Please enter email";
  } else if (
    !/^[\w.-]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,})+$/.test(rawInput.leadEmail.value)
  ) {
    rawInput.leadEmail.error = "Please enter valid email format";
  }
  return rawInput;
};

export const validateInput = (name: any, value: any) => {
  // name
  if (name === "name") {
    if ((!/^[a-zA-Z\s]+$/.test(value) && value !== "") || value.length > 30) {
      return false;
    }
  }
  if ((name === "phone" || name === "whatsapp") && value !== "") {
    if (!/^[0-9]+$/.test(value) || value.length > 10) {
      return false;
    }
  }

  if (name === "zipcode") {
    if (!/^[0-9]+$/.test(value) || value.length > 6) {
      return false;
    }
  }

  if (name === "address1" || name === "address2") {
    if (!/^[a-zA-Z0-9\s.,-]+$/.test(value) && value !== "") {
      return false;
    }
  }

  return true;
};

export const getFinalBodyStructure = (inputBody: any) => {
  let finalBody = {};
  for (const key in inputBody) {
    finalBody = {
      ...finalBody,
      [key]: ["country_id", "state_id"].includes(key)
        ? inputBody[key].id
        : inputBody[key].value,
    };
  }
  const newObj: any = { ...finalBody };

  ["doj"].forEach((key: any) => delete newObj[key]);

  return newObj;
};
